import { SessionModel } from "../schema/session.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class SessionThreadContainer extends MongoBaseContainer{
    session_thread: SessionModel
}